import style from './style'
import { useEffect, useState } from 'preact/hooks';

const Clock = (props) => {
    const [date, setDate] = useState(new Date());

    useEffect(() => {
        const timerID = setInterval(() => tick(), 5000);

        return function cleanup() {
            clearInterval(timerID);
        };
    });

    function tick() {
        setDate(new Date());
    }
    const months = 'января февраля марта апреля мая июня июля августа сентября октября ноября декабря'.split(' ');
    const formatedDate = () => {
        return date.getDate() + ' '
        + months[date.getMonth()] + ' '
        + date.getFullYear() + ', '
        + date.toLocaleTimeString(undefined, {hour12: false, hour: '2-digit', minute: '2-digit'}); //date.getHours() + ':' + date.getMinutes()
        };
    return (
        <span className={`${style['clock--' + props.site]} ${style['clock']}`}>{formatedDate()}</span>
    );
}

export default Clock;
